import { render, staticRenderFns } from "./FundsOperationsDetailsTable.vue?vue&type=template&id=d4bca4fe&scoped=true&"
import script from "./FundsOperationsDetailsTable.vue?vue&type=script&lang=js&"
export * from "./FundsOperationsDetailsTable.vue?vue&type=script&lang=js&"
import style0 from "./FundsOperationsDetailsTable.vue?vue&type=style&index=0&id=d4bca4fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4bca4fe",
  null
  
)

export default component.exports